// extracted by mini-css-extract-plugin
export default {"terms":"terms__MyKrV","oneClickTerms":"oneClickTerms__Hf6Bd","input":"input__ks6Ok","termsText":"termsText__ndUS_","termsSpan":"termsSpan__CrS7b","accordion":"accordion__uhGI1","errorMessageWrapper":"errorMessageWrapper__nFAjE"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"terms\":\"terms__MyKrV\",\"oneClickTerms\":\"oneClickTerms__Hf6Bd\",\"input\":\"input__ks6Ok\",\"termsText\":\"termsText__ndUS_\",\"termsSpan\":\"termsSpan__CrS7b\",\"accordion\":\"accordion__uhGI1\",\"errorMessageWrapper\":\"errorMessageWrapper__nFAjE\"}";
        // 1787130557196
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  